export default "__VITE_ASSET__fa2231b1__"